import Overview from "@/components/admin/Content/WebPages/Media/PressRelease/Overview";
import HeroSection from "@/components/admin/Content/WebPages/Media/PressRelease/HeroSection";
import FullPageSpinner from "@/components/ui/FullPageSpinner";
import { useWebPageForm } from "@/contexts/WebPageFormContext";

const PressRelease = () => {
  const { pageData, isLoading } = useWebPageForm();

  if (isLoading) {
    return <FullPageSpinner />
  }

  return (
    <div className="flex flex-col gap-8 lg:gap-12 p-4 md:p-8 lg:p-12 xl:w-3/4 mx-auto">
      <HeroSection data={pageData?.PRESS_RELEASE_BANNER ?? {
        sectionTag: 'PRESS_RELEASE_BANNER',
        contentType: 'WITH_FILE',
        title: 'Press Releases Banner'
      }} />
      <Overview data={pageData?.PRESS_RELEASE ?? {
        sectionTag: 'PRESS_RELEASE',
        contentType: 'WITHOUT_FILE',
        title: 'Our Press Releases'
      }} />
    </div>
  )
}

export default PressRelease